import React from 'react';
import { FlatButton } from 'material-ui';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Backdrop } from '@material-ui/core';
import PropTypes from 'prop-types';
import { red500, white } from '../../../theme/AllocateColors';
import Spinner from '../../common/Spinner/Spinner';
import globals from '../../../globals/communityGlobals';
import KeyboardDateSelector from '../../common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { getErrorProps, checkRequiredOnBlur } from '../../../utils/keyboardSelectorFunctions';
import { isDateFromBeforeDateTo, isValidDate, extractDateOnly } from '../../../utils/dates';

const errors = globals.getArea('error');
const locale = globals.getArea('referrals');

const initialState = {
  open: false,
  dateClosed: null,
  validationErrors: {},
};
export default class ReferralCloseDialog extends React.Component {
  state = initialState;

  setValidationErrors = newValidationErrors => {
    this.setState({ validationErrors: newValidationErrors });
  };

  handleOpen = () => {
    this.setState({ ...initialState, open: true });
    this.props.getReferralCloseDateRange(this.props.referralId);
  };

  handleHide = () => {
    this.setState({ open: false });
  };

  handleCloseReferral = async () => {
    const { closeReferral, referralId, getReferral } = this.props;
    const { dateClosed } = this.state;
    await closeReferral({ referralId, dateClosed });
    this.handleHide();
    getReferral(referralId);
  };

  handleDateChange = date => {
    let errorMsg = null;
    if (!date) errorMsg = errors.getMsg('requiredFieldValidationMessage');
    else date = extractDateOnly(date);

    this.setValidationErrors({ ...this.state.validationErrors, dateClosed: errorMsg });
    this.setState({ dateClosed: date });
  };

  noValidationErrors = () => {
    return isValidDate(this.state.dateClosed) && !this.state.validationErrors.dateClosed;
  };

  dateClosedIsInValidRange = () => {
    const { referralCloseDateRange } = this.props;
    const { minimumCloseDate, maximumCloseDate } = referralCloseDateRange;
    return (
      isDateFromBeforeDateTo(this.state.dateClosed, new Date(maximumCloseDate)) &&
      isDateFromBeforeDateTo(new Date(minimumCloseDate), this.state.dateClosed)
    );
  };

  dateClosedIsValid = () => {
    return this.noValidationErrors() && this.dateClosedIsInValidRange();
  };

  render() {
    const { isFetching, referralCloseDateRange, errorMessage } = this.props;
    const { canCloseReferral, minimumCloseDate, maximumCloseDate } = referralCloseDateRange;

    const { open, dateClosed, validationErrors } = this.state;

    return (
      <div>
        <Button variant="contained" onClick={this.handleOpen} style={{ backgroundColor: red500, color: white }}>
          {locale.getMsg('closeReferral')}
        </Button>

        <Backdrop open={open} style={{ zIndex: 9, backgroundColor: 'rgba(0,0,0,0.05)' }} />

        <Dialog
          open={open}
          onClose={this.handleHide}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle
            style={{ paddingTop: '4%', color: 'black', fontSize: '20px', fontWeight: 400 }}
            disableTypography
          >
            {locale.getMsg('closeReferral')}
          </DialogTitle>

          <DialogContent>
            <p style={{ color: 'grey' }}>{locale.getMsg('selectCloseDate')}</p>
            {isFetching ? (
              <Spinner />
            ) : (
              <div className="row">
                <div className="col-c2">
                  <KeyboardDateSelector
                    required
                    label={locale.getMsg('closeDate')}
                    value={dateClosed}
                    disabled={isFetching || !canCloseReferral}
                    onChange={this.handleDateChange}
                    onBlur={event =>
                      checkRequiredOnBlur(event.target.value, this.setValidationErrors, 'dateClosed', validationErrors)
                    }
                    errorProps={getErrorProps(validationErrors.dateClosed)}
                    minDate={minimumCloseDate ? new Date(minimumCloseDate) : null}
                    maxDate={maximumCloseDate ? new Date(maximumCloseDate) : null}
                  />
                </div>
              </div>
            )}

            {canCloseReferral !== undefined && !canCloseReferral && (
              <Typography color="error">{locale.getMsg('referralCannotBeClosed')}</Typography>
            )}
            {errorMessage && <Typography color="error">{errors.getMsg(errorMessage)}</Typography>}
          </DialogContent>

          <DialogActions>
            <FlatButton label={locale.getMsg('cancel')} primary onClick={this.handleHide} />
            <FlatButton
              label={locale.getMsg('ok')}
              primary
              keyboardFocused
              disabled={isFetching || !this.dateClosedIsValid() || !canCloseReferral}
              onClick={() => this.handleCloseReferral()}
            />
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ReferralCloseDialog.propTypes = {
  closeReferral: PropTypes.func.isRequired,
  referralId: PropTypes.number.isRequired,
  getReferralCloseDateRange: PropTypes.func.isRequired,
  getReferral: PropTypes.func.isRequired,
  referralCloseDateRange: PropTypes.shape({
    canCloseReferral: PropTypes.bool,
    minimumCloseDate: PropTypes.string,
    maximumCloseDate: PropTypes.string,
  }).isRequired,
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
};

ReferralCloseDialog.defaultProps = {
  errorMessage: null,
};
